<script context="module" lang="ts">
  export type ToggleOption = {
    label: string;
    value: any;
  }
  type Event = {
    change: ToggleOption
  }
</script>

<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let options: ToggleOption[];
  export let active = options[0];

  const dispatch = createEventDispatcher<Event>();

  function select (option: ToggleOption) {
    return () => {
      active = option;
      dispatch('change', option);
    }
  }
</script>

<div class="toggle-group">
  {#each options as option}
    <button class:active={active == option}
      on:click={select(option)}>{option.label}</button>
  {/each}
</div>

<style>
  .toggle-group {
    display: flex;
    box-sizing: border-box;
    height: 38px;
    /* padding: 0 2px; */
    border: 1px solid var(--_btn-pri-bg);
    border-radius: 40px;
    /* Prevents double-tap with this element */
    pointer-events: none;
  }

  .toggle-group button {
    margin: 2px;
    padding: var(--toggle-group__btn--padding, 5px 8px 6px);
    box-sizing: border-box;
    background-color: var(--toggle-group__btn--bgColor, transparent);
    border: none;
    border-radius: 500px;
    color: inherit;
    font-size: 14px;
    pointer-events: all;
  }

  .toggle-group button.active {
    background-color: var(--_btn-pri-bg);
    border-radius: 500px;
    color: var(--_btn-pri-c);
  }
</style>